module.exports = __webpack_public_path__ + "img/kiacharge-ic.fbb01f5e.svg";